/*
 * Arabic labels for the PDF viewer's controls.
 *
 * Without this, every control exposes an English accessible name on a fully
 * Arabic RTL site — an Arabic screen-reader user hears "Zoom in", "Full screen"
 * and so on. Key paths were taken from the installed @react-pdf-viewer packages,
 * so an unrecognised key would silently fall back to English rather than error.
 */

const viewerLocalizationAr = {
  core: {
    pageLabel: "صفحة {{pageIndex}}",
  },
  zoom: {
    zoomIn: "تكبير",
    zoomOut: "تصغير",
    zoomDocument: "مستوى التكبير",
    actualSize: "الحجم الأصلي",
    pageFit: "ملء الصفحة",
    pageWidth: "عرض الصفحة",
  },
  fullScreen: {
    enterFullScreen: "عرض بالشاشة الكاملة",
    exitFullScreen: "إنهاء العرض بالشاشة الكاملة",
  },
  scrollMode: {
    verticalScrolling: "تمرير رأسي",
    horizontalScrolling: "تمرير أفقي",
    wrappedScrolling: "تمرير متعدد الأعمدة",
  },
  selectionMode: {
    handTool: "أداة التحريك",
    textSelectionTool: "أداة تحديد النص",
  },
  search: {
    search: "بحث",
    enterToSearch: "اكتب ثم اضغط Enter للبحث",
    previousMatch: "النتيجة السابقة",
    nextMatch: "النتيجة التالية",
    close: "إغلاق",
    matchCase: "مطابقة حالة الأحرف",
    wholeWords: "كلمات كاملة",
  },
  bookmark: {
    noBookmark: "لا يوجد فهرس لهذا العدد",
  },
};

export default viewerLocalizationAr;
